import types from '/src/store/types'
import Cookies from 'js-cookie'
import { cloneDeep, map, difference, forEach } from 'lodash'
// import moment from 'moment'
import { api } from '@/api'

export default {
  addToCart: ({ commit }, dishId) => new Promise((resolve, reject) => {
    commit(types.cart.ADD_ITEM, dishId)
    resolve()
  }),
  removeFromCart: ({ commit }, dishId) => new Promise((resolve, reject) => {
    commit(types.cart.REMOVE_ITEM, dishId)
    resolve()
  }),
  removeLineFromCart: ({ commit }, dishId) => new Promise((resolve, reject) => {
    commit(types.cart.REMOVE_LINE, dishId)
    resolve()
  }),
  clearCart: ({ commit }) => new Promise((resolve, reject) => {
    commit(types.cart.CLEAR_CART)
    resolve()
  }),
  clearRedundantDishes: ({ rootGetters, getters, commit }) => new Promise(() => {
    let cartIds = map(getters.cart.lines, (line) => {
      return line.id
    })
    let allIds = map(rootGetters['menu/dishes'], (dish) => {
      return dish.ID
    })
    let diff = difference(cartIds, allIds)
    forEach(diff, (id) => {
      commit(types.cart.REMOVE_LINE, id)
    })
  }),
  createOrder: ({ commit, getters, dispatch }, formData) => new Promise((resolve, reject) => {
    let newForm = cloneDeep(formData)
    newForm.paymentMethod = formData.paymentMethod.code
    if (newForm.paymentMethod !== 'cash') {
      delete newForm.cashChange
    }

    let cookies = Cookies.get()
    delete cookies.vuex

    let requestData = {
      formData: newForm,
      cart: getters.cart.lines,
      clientData: {
        cookie: cookies
      },
      shopId: 1
    }

    api.createOrder(requestData).then(response => {
      dispatch('gtm/sendSimpleEvent', { category: 'Conversions', action: 'CreateOrder' }, { root: true })
      resolve(response.body)
    }).catch(error => {
      console.log('error', error)
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/cart/actions.js